// ============================================================================
// Name of active experiments mapped to relevant data
// ============================================================================

export interface Experiment {
    description: string;
    probability?: number; // Optional: only used for auto-assignment experiments
    dbName: string;
}

export const EXPERIMENTS: Record<string, Experiment> = {
    YODA: {
        description: 'Yoda welcome message',
        probability: 0.5,
        dbName: 'yoda',
    },
    EMAIL_FLOW_NEW_REFERRAL_TAG: {
        description: 'Email flow new referral tag',
        dbName: 'email_flow_new_referral_tag',
    },
    DYNAMIC_DASHBOARD_V8: {
        description: 'Dynamic Dashboard V8',
        dbName: 'dynamic_dashboard_v8',
    },
    ACCOUNT_DELETION_V082025: {
        description: 'Account deletion feature flag',
        dbName: 'account_deletion_v082025',
    },
    ADYEN_ACCOUNT: {
        description: 'Adyen payment processor integration',
        dbName: 'adyen_account',
    },
};
